module.exports = __webpack_public_path__ + "img/portfolio-04.5d178440.jpg";